var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL COMMUNICATION","title":"School Website","description":"Manage website news, blogs, galleries, events and shared resources.","count-label":"website tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }